<app-dialog-container>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <h1 mat-dialog-title>{{ title }}</h1>
    </div>
    <div>
      <button
        *ngIf="type === typeCesEnum.EDIT"
        mat-icon-button
        (click)="changeType(typeCesEnum.SHOW)">
        <mat-icon class="btn-show">visibility</mat-icon>
      </button>
      <button
        *ngIf="type === typeCesEnum.SHOW"
        mat-icon-button
        (click)="changeType(typeCesEnum.EDIT)">
        <mat-icon class="btn-edit">edit</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="delete()"
        *ngIf="type !== typeCesEnum.NEW">
        <mat-icon class="btn-delete">delete</mat-icon>
      </button>
    </div>
  </div>
  <!-- Indicador de progresso para geração de boletos -->
  <div *ngIf="isGeneratingBoletos" fxLayout="column"
    fxLayoutAlign="center center" fxLayoutGap="16" class="boleto-progress">
    <mat-spinner diameter="50"></mat-spinner>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8">
      <h3>Gerando Boletos...</h3>
      <p>{{ boletoProgressMessage }}</p>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8">
        <span>{{ processedBoletos }}/{{ totalBoletos }}</span>
        <mat-progress-bar mode="determinate"
          [value]="boletoProgressPercentage"></mat-progress-bar>
      </div>
    </div>
  </div>

  <div fxLayout="column" fxLayoutGap="8"
    [style.display]="isGeneratingBoletos ? 'none' : 'flex'">
    <div class="panel" fxFlex fxLayout="row" fxLayoutGap="8">
      <div fxFlex fxLayout="column" fxLayoutGap="8">
        <div fxFlex="60" class="panel" fxLayout="column" fxLayoutGap="4">
          <div fxFlex fxLayoutAlign="start center">
            <label class="title">MENSALIDADE</label>
          </div>
          <div fxFlex fxLayout="row" fxLayoutGap="2">
            <app-input
              fxFlex="160px"
              [config]="getFieldConfig('type')"
              [typeCes]="typeCes"
              [group]="form"></app-input>
            <app-input
              *ngIf="showSelectPlan"
              fxFlex="160px"
              [config]="getFieldConfig('plan')"
              [typeCes]="typeCes"
              [group]="form"
              (onSelect)="onSelectPlan($event)"></app-input>
            <app-input
              fxFlex="140px"
              [config]="getFieldConfig('parcel')"
              [typeCes]="typeCes"
              [group]="form"></app-input>
          </div>
          <div fxFlex fxLayout="row" fxLayoutGap="2">
            <app-input
              fxFlex="190px"
              [config]="getFieldConfig('firstDueDate')"
              [typeCes]="typeCes"
              [group]="form"></app-input>

            <app-input
              fxFlex="150px"
              [config]="getFieldConfig('monthlyValue')"
              [typeCes]="typeCes"
              [group]="form"></app-input>

            <app-input
              fxFlex="100px"
              [config]="getFieldConfig('fees')"
              [typeCes]="typeCes"
              [group]="form"></app-input>

            <app-input
              fxFlex="100px"
              [config]="getFieldConfig('fine')"
              [typeCes]="typeCes"
              [group]="form"></app-input>

            <app-input
              fxFlex="120px"
              [config]="getFieldConfig('discountValue')"
              [typeCes]="typeCes"
              [group]="form"></app-input>

            <app-input
              fxFlex="160px"
              [config]="getFieldConfig('totalPaidValue')"
              [typeCes]="typeCes"
              [group]="form"></app-input>
          </div>
        </div>

        <div fxFlex fxLayout="row" fxLayoutGap="2">
          <div fxFlex fxLayout="row" fxLayoutGap="2">
            <div
              fxFlex="initial"
              class="panel"
              fxLayout="column"
              fxLayoutGap="4">
              <div fxFlex="initial" fxLayoutAlign="start center">
                <label class="title">TAXA</label>
              </div>
              <div fxFlex fxLayout="row" fxLayoutGap="2">
                <app-input
                  class="app-input"
                  fxFlex="120px"
                  [config]="getFieldConfig('adhesionFee')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
                <app-input
                  class="app-input"
                  fxFlex="170px"
                  [config]="getFieldConfig('adhesionFeeDueDate')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>
            </div>

            <div
              fxFlex="initial"
              class="panel"
              fxLayout="column"
              fxLayoutGap="4">
              <div fxFlex="initial" fxLayoutAlign="start center">
                <label fxFlex class="title">IMPLANTAÇÃO</label>
              </div>
              <div fxFlex fxLayout="row" fxLayoutGap="2">
                <app-input
                  class="app-input"
                  fxFlex="120px"
                  [config]="getFieldConfig('deploymentValue')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
                <app-input
                  class="app-input"
                  fxFlex="170px"
                  [config]="getFieldConfig('deploymentDueDate')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>
            </div>

            <div
              fxFlex="initial"
              class="panel"
              fxLayout="column"
              fxLayoutGap="4">
              <div fxFlex="initial" fxLayoutAlign="start center">
                <label class="title">DIAS CORRIDOS</label>
              </div>
              <div fxFlex fxLayout="row" fxLayoutGap="2">
                <app-input
                  class="app-input"
                  fxFlex="120px"
                  [config]="getFieldConfig('daysCountValue')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
                <app-input
                  class="app-input"
                  fxFlex="170px"
                  [config]="getFieldConfig('daysCountDueDate')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>
            </div>
          </div>
        </div>
        <div fxFlex="initial" fxLayout="row" fxLayoutGap="20">
          <div fxFlex></div>
          <app-input
            fxFlex
            [config]="getFieldConfig('generateBill')"
            [typeCes]="typeCes"
            [group]="form"></app-input>
          <app-input
            fxFlex
            [config]="getFieldConfig('sendEmail')"
            [typeCes]="typeCes"
            [group]="form"></app-input>
          <app-input
            fxFlex
            [config]="getFieldConfig('feeFirstMonthly')"
            [typeCes]="typeCes"
            [group]="form"></app-input>
          <app-input
            fxFlex
            [config]="getFieldConfig('annualPaid')"
            [typeCes]="typeCes"
            [group]="form"></app-input>
          <div fxFlex></div>
        </div>
      </div>
    </div>

    <div fxFlex fxLayout="row" fxLayoutAlign="end">
      <div fxFlex="initial">
        <button mat-raised-button class="add-item" (click)="addItem()"
          [disabled]="!(form.value?.type && form.get('totalPaidValue')?.getRawValue())">
          <mat-icon>add</mat-icon> ADICIONAR
        </button>
      </div>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="10">
      <div fxFlex="90">
        <div class="items">
          <table
            mat-table
            #table
            [dataSource]="dataSource"
            class="mat-elevatio-4">
            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef>CÓDIGO</th>
              <td mat-cell *matCellDef="let element">{{ element.code }}</td>
            </ng-container>
            <ng-container matColumnDef="origin">
              <th mat-header-cell *matHeaderCellDef>ORIGEM</th>
              <td mat-cell *matCellDef="let element">{{ element.origin }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>TIPO</th>
              <td mat-cell *matCellDef="let element">{{ element.type }}</td>
            </ng-container>
            <ng-container matColumnDef="parcel">
              <th mat-header-cell *matHeaderCellDef>PARCELA</th>
              <td mat-cell *matCellDef="let element">{{ element.parcel }}</td>
            </ng-container>
            <ng-container matColumnDef="ourNumber">
              <th mat-header-cell *matHeaderCellDef>NOSSO NÚMERO</th>
              <td mat-cell *matCellDef="let element">
                {{ element.ourNumber }}
              </td>
            </ng-container>
            <ng-container matColumnDef="document">
              <th mat-header-cell *matHeaderCellDef>DOCUMENTO</th>
              <td mat-cell *matCellDef="let element">{{ element.document }}</td>
            </ng-container>
            <ng-container matColumnDef="emissionDate">
              <th mat-header-cell *matHeaderCellDef>DATA EMISSÃO</th>
              <td mat-cell *matCellDef="let element">
                {{ element.emissionDate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef>DATA VENCIMENTO</th>
              <td mat-cell *matCellDef="let element">{{ element.dueDate }}</td>
            </ng-container>
            <ng-container matColumnDef="delayDays">
              <th mat-header-cell *matHeaderCellDef>DIAS ATRAZO</th>
              <td mat-cell *matCellDef="let element">
                {{ element.delayDays }}
              </td>
            </ng-container>
            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef>VALOR</th>
              <td mat-cell *matCellDef="let element">
                {{ element.value | currency : "BRL" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountValue">
              <th mat-header-cell *matHeaderCellDef>DESCONTO</th>
              <td mat-cell *matCellDef="let element">
                {{ element.discountValue | currency : "BRL" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>TOTAL</th>
              <td mat-cell *matCellDef="let element">
                {{ element.total | currency : "BRL" }}
              </td>
            </ng-container>
            <ng-container matColumnDef="fees">
              <th mat-header-cell *matHeaderCellDef>JUROS (%)</th>
              <td mat-cell *matCellDef="let element">{{ element.fees |
                number:'1.2-2':'pt-BR' }}</td>
            </ng-container>
            <ng-container matColumnDef="fine">
              <th mat-header-cell *matHeaderCellDef>MULTA (%)</th>
              <td mat-cell *matCellDef="let element">{{ element.fine |
                number:'1.2-2':'pt-BR' }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <!-- delete -->
                <button mat-icon-button (click)="openDelete(element)">
                  <mat-icon class="btn-delete">delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
              class="table-row"></tr>
            <tr
              tabindex="999"
              #rowDef
              mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
              class="table-row"></tr>
          </table>
        </div>
      </div>
      <div fxFlex="10" fxLayoutAlign="end center" fxLayoutGap="8">
        <button class="custom-button" type="button" mat-raised-button
          (click)="clear()">
          LIMPAR
        </button>
        <button class="custom-button" type="button" mat-raised-button
          (click)="cancel()">
          CANCELAR
        </button>
        <button
          *ngIf="typeCes !== typeCesEnum.SHOW"
          class="custom-button btn-save"
          type="submit"
          variant="contained"
          mat-raised-button
          [disabled]="dataSource.data.length === 0"
          (click)="save()">
          SALVAR
        </button>
      </div>
    </div>
  </div>
  <div class="loading-overlay" *ngIf="isDownloading">
    <div class="loading-box">
      <div class="spinner"></div>

      <h3>Preparando Arquivos...</h3>

      <p>Por favor, aguarde. Estamos gerando seus PDFs.</p>

      <div class="progress-status" *ngIf="downloadTotal > 1">
        Processado: <strong>{{ downloadProgress }}</strong> de <strong>{{ downloadTotal }}</strong>
      </div>

      <div class="progress-bar-container" *ngIf="downloadTotal > 1">
        <div class="progress-bar-fill" [style.width.%]="(downloadProgress / downloadTotal) * 100"></div>
      </div>
    </div>
  </div>
</app-dialog-container>
